import ChartCfg from '@antv/g2/lib/chart/chart'
import { G2TooltipCfg, ChartAttributeCfg } from '@/types/common/g2Charts'
import { g2DefaultCfg } from '../config'
const {
  sliderFn,
  YAxisFn,
  lineFillColorFn,
  tooltipText,
  tooltipText2,
  annotationTextFn
} = g2DefaultCfg

const lineFillColor = lineFillColorFn()

/**
 *
 * @param chart g2 chart
 * @param slider 缩略轴 状态
 */
function handleSlider (chart: ChartCfg, slider: boolean): number {
  let offsetY = -20
  if (slider) {
    offsetY += 50
    chart.option('slider', sliderFn())
  }
  return offsetY
}

function handleScale (chart: ChartCfg, name: string) {
  chart.scale({
    value: {
      alias: name
    }
  })
}

function handleAxis (chart: ChartCfg) {
  chart.axis('value', YAxisFn())
}

function handleChartType (chart: ChartCfg, type: string, position: string) {
  if (type === 'Line') {
    chart
      .line()
      .position('date*' + position)
      .color(position, lineFillColor.line)
  } else {
    chart
      .interval()
      .position('date*' + position)
      .color(position, lineFillColor.bar)
  }
}

function handleInteraction (
  chart: ChartCfg,
  type: string,
  LChartType: string,
  RChartType: string
): ChartCfg {
  chart.interaction('element-visible-filter')
  switch (type) {
    case 'line':
      handleChartType(chart, 'Line', 'value')
      break
    case 'bar':
      handleChartType(chart, 'Bar', 'value')
      break
    case 'multiaxial':
    default:
      handleChartType(chart, LChartType, 'YLeft')
      handleChartType(chart, RChartType, 'YRight')
      break
  }
  return chart
}

export function handleType (chart: ChartCfg, opts: ChartAttributeCfg): ChartCfg {
  const { options, slider, type } = opts
  const {
    topName,
    topName1,
    name,
    position,
    axisShow,
    LChartType,
    RChartType
  } = options

  const offsetY = handleSlider(chart, slider)

  switch (type) {
    case 'line':
    case 'bar':
      handleScale(chart, name)
      handleAxis(chart)
      if (axisShow) {
        chart.annotation().text({
          position: position[0],
          content: topName,
          ...annotationTextFn({ offsetY })
        })
      }

      chart.tooltip({
        showCrosshairs: true,
        customContent (title: string, data: G2TooltipCfg[]) {
          return tooltipText(title, data, topName)
        }
      })
      break
    case 'multiaxial':
    default:
      chart.scale({
        YLeft: {
          alias: name
        },
        YRight: {
          alias: name
        }
      })
      chart.axis('YLeft', YAxisFn())
      chart.axis('YRight', YAxisFn())
      if (axisShow) {
        chart.annotation().text({
          position: position[0],
          content: topName,
          ...annotationTextFn({ offsetY })
        })
        chart.annotation().text({
          position: position[1],
          content: topName1,
          ...annotationTextFn({
            style: {
              textAlign: 'end'
            },
            offsetY,
            offsetX: 50
          })
        })
      }
      chart.tooltip({
        showCrosshairs: true,
        customContent (title: string, data: G2TooltipCfg[]) {
          return tooltipText2(title, data, topName, topName1, 'Line', 'Bar')
        }
      })
      break
  }
  return handleInteraction(chart, type, LChartType, RChartType)
}
